import { Checkbox, FormControlLabel } from "@mui/material";
import type { FC } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import type { MomentFormMoment } from "../../moment/types/moment-form-moment";
import { SegmentForm } from "./segment-form";
import type { ToFormProps } from "./to-forms/types";

export const ChannelTarget: FC<ToFormProps> = ({
  formDisabled,
  continueClicked,
  restrictedSegments,
}) => {
  const {
    control,
    formState: { submitCount },
    setValue,
    getValues,
  } = useFormContext<MomentFormMoment>();
  useWatch({ control, name: "notify_channel" });
  const notify_channel = getValues("notify_channel");

  return (
    <>
      <FormControlLabel
        sx={{ mt: 2 }}
        control={
          <Controller
            name="notify_channel"
            control={control}
            render={({ field }) => (
              <Checkbox
                checked={field.value}
                disabled={formDisabled}
                onChange={(event) => {
                  setValue("target_channel", !event.target.checked);
                  field.onChange(event);
                }}
                data-testid="notify-channel-checkbox"
              />
            )}
          />
        }
        label="Send based on an automated trigger e.g. birthday, start date etc."
      />
      {notify_channel && (
        <>
          <h3>Who is the trigger for? E.g. whose birthday, start date etc.</h3>
          <SegmentForm
            disabled={formDisabled}
            showValidationErrors={continueClicked || submitCount > 0}
            // TODO: connectionCategories
            connectionCategories={[]}
            restrictedSegments={restrictedSegments}
          />
        </>
      )}
    </>
  );
};
